import { Translatable } from "@icc/shared/helpers";

/** Listwa końcowa */
export class EndRail {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    shutterTypes: number[];
    colorGroupSetId: number;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
}
